module.exports = __webpack_public_path__ + "images/halloween_lp/dot_triangle_380fead0dacceaf3a75df799ea540944.png";